export class DisplayedRatePlanCode {

  constructor(public ratePlanCode: string, public closeable: boolean) {
    this.ratePlanCode = ratePlanCode;
    this.closeable = closeable;
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/rate-plan-code/rate-plan-code/displayed-rate-plan-code.ts